var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1935_12444)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0469C0 8.86428 1.26428 5.81203 3.51472 3.56159C5.76516 1.31116 8.8174 0.046875 12 0.046875C15.1826 0.046875 18.2348 1.31116 20.4853 3.56159C22.7357 5.81203 24 8.86428 24 12.0469C24 15.2295 22.7357 18.2817 20.4853 20.5322C18.2348 22.7826 15.1826 24.0469 12 24.0469C8.8174 24.0469 5.76516 22.7826 3.51472 20.5322C1.26428 18.2817 0 15.2295 0 12.0469ZM12 6.04688C12.2984 6.04688 12.5845 6.1654 12.7955 6.37638C13.0065 6.58736 13.125 6.87351 13.125 7.17188V12.4219C13.125 12.7202 13.0065 13.0064 12.7955 13.2174C12.5845 13.4283 12.2984 13.5469 12 13.5469C11.7016 13.5469 11.4155 13.4283 11.2045 13.2174C10.9935 13.0064 10.875 12.7202 10.875 12.4219V7.17188C10.875 6.87351 10.9935 6.58736 11.2045 6.37638C11.4155 6.1654 11.7016 6.04688 12 6.04688ZM12 15.0469C11.6022 15.0469 11.2206 15.2049 10.9393 15.4862C10.658 15.7675 10.5 16.149 10.5 16.5469C10.5 16.9447 10.658 17.3262 10.9393 17.6075C11.2206 17.8888 11.6022 18.0469 12 18.0469H12.0105C12.4083 18.0469 12.7899 17.8888 13.0712 17.6075C13.3525 17.3262 13.5105 16.9447 13.5105 16.5469C13.5105 16.149 13.3525 15.7675 13.0712 15.4862C12.7899 15.2049 12.4083 15.0469 12.0105 15.0469H12Z",
    fill: "#D1A20F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1935_12444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.046875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.dbccd89d9b468714b0af5232c66b34b0.svg";
export { ForwardRef as ReactComponent };